import { render, staticRenderFns } from "./FQDNRecords.vue?vue&type=template&id=634ca246&scoped=true"
import script from "./FQDNRecords.vue?vue&type=script&lang=js"
export * from "./FQDNRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634ca246",
  null
  
)

export default component.exports